type SelectionCardStyles = Readonly<{
	borderBackgroundColor: string;
	borderColor: string;
	backgroundColor: string;
}>;

type Result = ModelHookResult<SelectionCardStyles, undefined>;

const SELECTION_CARD_STYLES = {
	checked: {
		borderBackgroundColor: 'linear-gradient(275deg, #0139BC 2.93%, #4BAEFF 96.39%)',
		borderColor: 'sunrise.semantic.stroke.weaker',
		backgroundColor: 'sunrise.semantic.fill.accent.primary.weaker',
	},
	unchecked: {
		borderBackgroundColor: 'transparent',
		borderColor: 'sunrise.semantic.stroke.weaker',
		backgroundColor: 'sunrise.semantic.fill.inverse.strong',
	},
} as const;

export function useSelectionCard(checked: boolean): Result {
	return { data: checked ? SELECTION_CARD_STYLES.checked : SELECTION_CARD_STYLES.unchecked };
}
